export enum CurrencyType {
  POINTS = 'points',
  STAMPS = 'stamps',
  CASHBACK = 'cashback'
}

export enum CurrencyTypeWithDiscount {
  POINTS = 'points',
  STAMPS = 'stamps',
  CASHBACK = 'cashback',
  DISCOUNT = 'discount'
}

export enum PointRewardTransactionType {
  FLAT_CREDIT = 'flat_credit',
  PERCENTAGE_CREDIT = 'pct_credit',
  MANUAL_ADJUSTMENT = 'adjust',
  STEPPED_CREDIT = 'stepped_credit'
}

export enum DiscountRewardTransactionType {
  FLAT_OFF = 'flat_off',
  PERCENTAGE_OFF = 'pct_off',
  STEPPED_OFF = 'stepped_off'
}

export type RewardChannel = 'in_store' | 'ecom' | 'both';

export const REWARD_CHANNEL_LABELS: Record<RewardChannel, string> = {
  in_store: 'IN-STORE ONLY',
  ecom: 'E-COMMERCE ONLY',
  both: 'IN-STORE & E-COMMERCE'
};
